/**
 * Convert given list of consents to supported format
 * @returns
 */
const TCFConvertConsentToSupportedFormat = (consentList: {
  [key: string]: boolean | undefined;
}): number[] => {
  // Encode to supported string
  return Object.entries(consentList)
    .filter(([, isAccepted]) => isAccepted)
    .map(([id]) => Number(id));
};

export default TCFConvertConsentToSupportedFormat;
